<template>
  <div v-if="artwork" class="apple-background" :class="{'has-flow': flowEnabled}" :style="backgroundStyle" aria-hidden="true">
    <img :key="artwork" :src="artwork" alt="" @error="onImageError" />
    <div class="apple-background-wash" />
  </div>
</template>
<script>
import { runtime } from '../bridge';
import { wallpaper } from '../salt/wallpaper';
export default {
  name: 'AppleBackground',
  data() { return { state: runtime.state, wallpaper, failed: [] }; },
  computed: {
    trackArtwork() { const track = this.state.tracks.find(item => item.id === this.state.currentId); return track ? runtime.cover(track) : ''; },
    artwork() { return [this.wallpaper.url, this.trackArtwork].find(url => url && !this.failed.includes(url)) || ''; },
    flowEnabled() { return this.wallpaper.flow > 0 && this.state.motionLevel !== 'off'; },
    backgroundStyle() { return { '--apple-wallpaper-blur': `${this.wallpaper.customBlur ? this.wallpaper.blur : 60}px`, '--apple-wallpaper-flow': String(this.wallpaper.flow / 100) }; },
  },
  watch: {
    'state.currentId'() { this.failed = []; },
    'wallpaper.url'() { this.failed = []; },
  },
  mounted() { window.addEventListener('online', this.retryArtwork); },
  beforeDestroy() { window.removeEventListener('online', this.retryArtwork); },
  methods: {
    onImageError(event) {
      // An error from a replaced image must not mark the new source as bad.
      const source = event.target.getAttribute('src');
      if (source && source === this.artwork && !this.failed.includes(source)) this.failed = [...this.failed, source];
    },
    retryArtwork() { this.failed = []; },
  },
};
</script>
<style scoped>
.apple-background { position:fixed; inset:0; z-index:0; overflow:hidden; pointer-events:none; }
.apple-background img { position:absolute; inset:-240px; width:calc(100% + 480px); height:calc(100% + 480px); object-fit:cover; filter:blur(var(--apple-wallpaper-blur)); }
.apple-background-wash { position:absolute; inset:0; background:color-mix(in srgb,var(--color-body-bg) 92%,transparent); }
.apple-background.has-flow img { animation:apple-wallpaper-motion 24s ease-in-out infinite alternate; }
.apple-background.has-flow::after { content:''; position:absolute; inset:-20%; background:linear-gradient(115deg,transparent 25%,rgb(255 255 255 / .16) 48%,transparent 72%); opacity:var(--apple-wallpaper-flow); mix-blend-mode:soft-light; animation:apple-wallpaper-shine 16s ease-in-out infinite alternate; }
@keyframes apple-wallpaper-motion { from { transform:scale(1.03) translate3d(-1%,0,0); } to { transform:scale(1.06) translate3d(1%,.5%,0); } }
@keyframes apple-wallpaper-shine { from { transform:translateX(-15%); } to { transform:translateX(15%); } }
@media (prefers-reduced-motion:reduce) { .apple-background.has-flow img,.apple-background.has-flow::after { animation:none; } }
@media (prefers-reduced-transparency:reduce) { .apple-background { display:none; } }
</style>
